//////////////////
// Investment Map Controller
//////////////////
App.InvestmentMap = (function() {

	var mapCollection = [];
	var selectors = {
		map: ".investment-map"
	};

	App.register(function() {
		App.log("Registered: App.InvestmentMap");
	});

	return {
		initMap: function(mapId, mapPayload) {
			try {
				var map = new InvestmentMap(
					mapId, mapPayload
				);
				map.render();
				mapCollection.push(map);
			} catch(e) {
				console.log(e);
			}
		}
	}

})();
